export const SHOW_SPINNER = 'SHOW_SPINNER'
export const HIDE_SPINNER = 'HIDE_SPINNER'

const sSpinner = text =>({
    type : SHOW_SPINNER,
    payload: {text}
})

const hSpinner = () =>({
    type : HIDE_SPINNER
})

export function showSpinner (text){
    return sSpinner(text)
}

export function hideSpinner (){
    return hSpinner()
}